// extracted by mini-css-extract-plugin
var _1 = "tntg-speaker";
var _2 = "tntg-speaker-description";
var _3 = "tntg-speaker-img";
var _4 = "tntg-speaker-name";
var _5 = "tntg-speaker-wrap";
export { _1 as "tntg-speaker", _2 as "tntg-speaker-description", _3 as "tntg-speaker-img", _4 as "tntg-speaker-name", _5 as "tntg-speaker-wrap" }
